"use client";

import { useEffect } from "react";
import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";
import type { ReactElement } from "react";

export default function ErrorPage({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}): ReactElement {
    useEffect(() => {
        Logger.error(ServiceType.WEB, "Global error page (layout)", {
            tag: LogTag.ERROR,
            error,
        });
    }, [error]);

    return (
        <main
            style={{
                minHeight: "100svh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "24px",
                boxSizing: "border-box",
            }}
        >
            <div role="alert">
                <h1>Something went wrong</h1>
                <p>
                    We're sorry, but something went wrong on our end. Please try refreshing the
                    page.
                </p>
                <button type="button" onClick={reset}>
                    Try again
                </button>
            </div>
        </main>
    );
}
